
define('text!views/wellness/activity.html',[],function () { return '<div class="wellness-account-activity-status js-wellness-account-activity-status"></div>\r\n\r\n<div class="wellness-account-activity-name"><%- this.activity.name %></div>\r\n\r\n<div class="wellness-account-activity-earning">$<%- this.activity.amount %></div>';});

